module.exports = {
    PROGRAM_SCHEDULE_GET: 'PROGRAM_SCHEDULE_GET',
    PROGRAM_SCHEDULE_UPDATE: 'PROGRAM_SCHEDULE_UPDATE',
};
